import React from 'react';
import { Skeleton } from './Skeleton';

/**
 * Full Page Skeleton
 * Used for system-level loading (auth, service initialization)
 */
const FullPageSkeleton: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center space-y-4">
        {/* Logo/Brand Skeleton */}
        <div className="flex justify-center mb-6">
          <Skeleton className="p-4 rounded-xl" style={{ width: 64, height: 64 }} />
        </div>

        {/* Loading Message */}
        {message && <p className="text-gray-600 text-sm animate-pulse">{message}</p>}

        {/* Progress Indicator */}
        <div className="flex justify-center gap-2">
          <Skeleton className="rounded-full" style={{ width: 8, height: 8 }} />
          <Skeleton className="rounded-full" style={{ width: 8, height: 8 }} />
          <Skeleton className="rounded-full" style={{ width: 8, height: 8 }} />
        </div>
      </div>
    </div>
  );
};

export default FullPageSkeleton;
